class MainCartSection extends HTMLElement {
    constructor() {
        super();
        this.itemsContainer = this.querySelector('.main-cart__items-container');
        this.footerAmount = this.querySelector('.main-cart__total-cost-subtotal');
        this._debounceTimers = {};
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
    }
    connectedCallback() {
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
    }
    disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
    }
    _onClick(e) {
        const adjustBtn = e.target.closest('.main-cart-__qty-adjust');
        if (adjustBtn) {
            const line = parseInt(adjustBtn.dataset.line, 10) || 0;
            const isPlus = adjustBtn.classList.contains('main-cart-__qty--plus');
            const isMinus = adjustBtn.classList.contains('main-cart-__qty--minus');
            const inputs = Array.from(this.querySelectorAll('input.main-cart__qty-input[data-line="' + line + '"]'));
            let curQty = parseInt(String(inputs[0]?.value || '').replace(/\D/g, ''), 10) || 0;
            let nextQty = curQty;
            if (isPlus) nextQty = curQty + 1;
            if (isMinus) nextQty = Math.max(curQty - 1, 0);
            inputs.forEach((inputEl) => { inputEl.value = String(nextQty); });
            if (line > 0) this._debouncedUpdate(line, nextQty);
            return;
        }
        const removeLink = e.target.closest('.cart-remove-button-link');
        if (removeLink) {
            e.preventDefault();
            const wrapper = removeLink.closest('cart-remove-button');
            const line = parseInt(wrapper?.dataset.index, 10) || 0;
            if (line > 0) {
                const inputs = Array.from(this.querySelectorAll('input.main-cart__qty-input[data-line="' + line + '"]'));
                inputs.forEach((inputEl) => { inputEl.value = '0'; });
                this._debouncedUpdate(line, 0);
            }
        }
    }
    _onChange(e) {
        const input = e.target.closest('input.main-cart__qty-input');
        if (input) {
            const line = parseInt(input.dataset.line, 10) || 0;
            let qty = parseInt(String(input.value).replace(/\D/g, ''), 10);
            if (isNaN(qty) || qty < 0) qty = 0;
            if (line > 0) {
                const peers = Array.from(this.querySelectorAll('input.main-cart__qty-input[data-line="' + line + '"]'));
                peers.forEach((el) => { if (el !== input) el.value = String(qty); });
                this._debouncedUpdate(line, qty);
            }
        }
    }
    _debouncedUpdate(line, qty) {
        const key = String(line);
        if (this._debounceTimers[key]) {
            clearTimeout(this._debounceTimers[key]);
        }
        this._debounceTimers[key] = setTimeout(() => {
            delete this._debounceTimers[key];
            this._updateCart(line, qty);
        }, 500);
    }
    _updateCart(line, qty) {
        if (this.itemsContainer) {
            this.itemsContainer.classList.add('is-loading');
        }
        const inputs = Array.from(this.querySelectorAll('input.main-cart__qty-input'));
        const lineMap = new Map();
        inputs.forEach((input) => {
            const l = parseInt(input.dataset.line, 10) || 0;
            const cur = parseInt(String(input.value).replace(/\D/g, ''), 10) || 0;
            lineMap.set(l, l === line ? qty : cur);
        });
        const sortedLines = Array.from(lineMap.keys()).sort((a, b) => a - b);
        const fd = new FormData();
        sortedLines.forEach((l) => {
            fd.append('updates[]', lineMap.get(l) || 0);
        });
        const action = '/cart';
        fetch(action, { method: 'POST', body: fd, credentials: 'same-origin', redirect: 'manual' })
            .then(() => this._refreshSections())
            .catch(() => this._refreshSections());
    }
    _refreshSections() {
        const url = window.location.pathname + window.location.search;
        const requestUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + ['header', 'main-cart'].join(',');
        fetch(requestUrl, { credentials: 'same-origin' })
            .then((res) => res.json())
            .then((data) => {
                const headerHtml = data.header || '';
                const mainCartHtml = data['main-cart'] || '';
                if (mainCartHtml) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(mainCartHtml, 'text/html');
                    const newSection = doc.querySelector('main-cart-section');
                    if (newSection) {
                        this.className = newSection.className;
                    }
                    const newItems = doc.querySelector('.main-cart__items-container');
                    if (newItems && this.itemsContainer) {
                        this.itemsContainer.replaceWith(newItems);
                        this.itemsContainer = this.querySelector('.main-cart__items-container');
                    }
                    const newFooterAmount = doc.querySelector('.main-cart__total-cost-subtotal');
                    if (newFooterAmount) {
                        if (!this.footerAmount) this.footerAmount = this.querySelector('.main-cart__total-cost-subtotal');
                        if (this.footerAmount) {
                            this.footerAmount.replaceWith(newFooterAmount);
                            this.footerAmount = newFooterAmount;
                        }
                    }
                }
                if (headerHtml) {
                    const parser2 = new DOMParser();
                    const doc2 = parser2.parseFromString(headerHtml, 'text/html');
                    const newCountEl = doc2.querySelector('.CartCount');
                    const countText = newCountEl ? newCountEl.textContent : '';
                    const countVal = parseInt(countText, 10) || 0;
                    const allCounts = document.querySelectorAll('.CartCount');
                    allCounts.forEach((el) => {
                        el.textContent = String(countVal);
                        el.classList.toggle('hidden-count', countVal === 0);
                    });
                    const newDrawerNodes = doc2.querySelectorAll('#CartCounterContent, .drawer__cart-counter');
                    const drawerText = newDrawerNodes.length ? newDrawerNodes[0].textContent : '';
                    const currentDrawerNodes = document.querySelectorAll('#CartCounterContent, .drawer__cart-counter');
                    currentDrawerNodes.forEach((el) => {
                        el.textContent = drawerText;
                    });
                    const newDrawerCart = doc2.querySelector('#CartDrawer .drawer__cart');
                    const currentDrawerCart = document.querySelector('#CartDrawer .drawer__cart');
                    if (newDrawerCart && currentDrawerCart) {
                        currentDrawerCart.replaceWith(newDrawerCart);
                    }
                }
            })
            .finally(() => {
                const container = this.querySelector('.main-cart__items-container');
                if (container) container.classList.remove('is-loading');
                const drawerInner = document.querySelector('.cart-drawer__inner');
                if (drawerInner) drawerInner.classList.remove('is-loading');
            });
    }
    handleExternalUpdate(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('main-cart-section');
        if (newSection) {
            this.className = newSection.className;
        }
        const newItems = doc.querySelector('.main-cart__items-container');
        if (newItems && this.itemsContainer) {
            this.itemsContainer.replaceWith(newItems);
            this.itemsContainer = this.querySelector('.main-cart__items-container');
        }
        const newFooterAmount = doc.querySelector('.main-cart__total-cost-subtotal');
        if (newFooterAmount) {
            if (!this.footerAmount) this.footerAmount = this.querySelector('.main-cart__total-cost-subtotal');
            if (this.footerAmount) {
                this.footerAmount.replaceWith(newFooterAmount);
                this.footerAmount = newFooterAmount;
            }
        }
    }
}
customElements.define('main-cart-section', MainCartSection);
